import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

export interface VendorExportHealth {
  status: 'failed' | 'succeeded';
  attemptedAt: string;
  firstFailedAt: string | null;
  message: string;
  reason: string;
  httpStatus: number | null;
  consecutiveFailures: number;
  action: string;
  lastSuccessfulAt: string | null;
  lastFailure?: { attemptedAt: string; stage: string } | null;
  recordCount: number;
  batchId: string;
}

@Component({
    selector: 'app-vendor-export-health',
    imports: [CommonModule],
    templateUrl: './vendor-export-health.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: ['.export-failed { color: #b71c1c; } .batch-id { overflow-wrap: anywhere; font-size: 12px; }']
})
export class VendorExportHealthComponent {
  @Input() health?: VendorExportHealth;
}
